import { cloneDeep } from "lodash";
import { allBudgetTypesOptions, allClassificationTypesOptions, allDataSourcesOptions, allMeasureUnitsOptions, allPaymentTypesOptions, allMutuallyRedeemingLevelOptions, allMutuallyRedeemingOptions, allPeriodicitiesOptions, allReportNamesOptions, allReportTypesOptions } from "../../common/baseOptions";
import { Classificator } from "../../common/types/Classificator";
import { Indicator } from "../../common/types/Indicator";
import { Template } from "../../common/types/Template";
import { ReportDviFilterSettings } from "./settings/ReportDviFilterSettings";
import { ReportDviFilterOptions } from "./options/ReportDviFilterOptions";
import { ClassificationType, PaymentType } from "../../common/types/roots/fields";
import { Option } from "../../common/types/Option";

export const reportDviIncomesClassificators: Classificator[] = [
    { key: 'kat', active: true, selected: [] },
    { key: 'cls', active: true, selected: [] },
    { key: 'pcl', active: true, selected: [] },
    { key: 'spf', active: true, selected: [] }
]

export const reportDviExpensesClassificators: Classificator[] = [
    { key: 'gr',  active: false, selected: [] },
    { key: 'pgr', active: false, selected: [] },
    { key: 'abp', active: true, selected: [] },
    { key: 'prg', active: true, selected: [] },
    { key: 'ppr', active: true, selected: [] },
    { key: 'spf', active: true, selected: [] },
]

const reportDviClassificationTypeValues = [
    "INCOMES",
    "EXPENSES"
]
export const reportDviClassificationTypeOptions: Option<ClassificationType>[] = allClassificationTypesOptions.filter(
    o => reportDviClassificationTypeValues.includes(o.value)
)

export const reportDviIndicators: Indicator[] = []

// Нужна как временная затычка (При созданий нового берутся пустые настройки)
const tempSettings: ReportDviFilterSettings = {
    // Base:
    reportName: 'DVI',
    reportType: 'REGULATED',
    classificationType: 'EXPENSES',
    dataSource: 'LOADER',
    periodicity: 'PERIOD',
    // Custom:
    period: { from: '', to: '' },
    budgetTypes: [],
    region: '',
    paymentType: 'OBLIGATIONS',
    mutuallyRedeeming: 'WITHOUT',
    mutuallyRedeemingLevels: [],
    measureUnit: 'THOUSAND',
    roundUpTo: null,
    incomes: [],
    expenses: []
}

export const reportDviBaseTemplate: Template = {
    id: null,
    name: 'Динамика внесенных изменений в ПФ и СПП годовые изменения',
    excelName: null,
    description: null,
    category: '60',
    regions: [],
    userId: '',
    filterSettings: tempSettings
}

export const reportDviFilterOptions: ReportDviFilterOptions = {
    // Base:
    key: 'DVI',
    reportNames: cloneDeep(allReportNamesOptions),
    reportTypes: cloneDeep(allReportTypesOptions),
    classificationTypes: cloneDeep(reportDviClassificationTypeOptions),
    dataSources: cloneDeep(allDataSourcesOptions),
    periodicities: cloneDeep(allPeriodicitiesOptions),
    // Custom:
    mutuallyRedeeming: cloneDeep(allMutuallyRedeemingOptions),
    mutuallyRedeemingLevels: cloneDeep(allMutuallyRedeemingLevelOptions),
    measureUnits: cloneDeep(allMeasureUnitsOptions),
    budgetTypes: cloneDeep(allBudgetTypesOptions).filter(it => it.value !== 1),
    regions: [], // Загружается с бэка
    paymentTypes: cloneDeep(allPaymentTypesOptions),
    incomes: cloneDeep(reportDviIncomesClassificators),
    expenses: cloneDeep(reportDviExpensesClassificators)
}
